import React, { useState, useEffect, useContext } from "react"
import get from "lodash/get"
import { graphql } from "gatsby"
import PageLayout from "../layouts/page/page.layout"
import { CourseCardsSection } from "../page-styles/courses.styles"
import Grid from "../components/grid/grid.component"
import EmailSubscribeHorizontal from "../components/email-subscribe-horizontal/email-subscribe-horizontal.component"
import SingleCTA from "../components/single-cta/single-cta.component"
import { Seo } from "../components/seo"
import CoursesPageHero from "../components/courses-page-hero/courses-page-hero.component.jsx"
import { HeroDescriptionContainer } from "../page-styles/general.styles"
import {
  CoursesSection,
  CoursesContainer,
  SmallTextLinkContainer,
  LabelContainer,
  ResultText,
  SearchSortContainer
} from "../page-styles/courses.styles"
import NoCourseResults from "../components/course-filter/course-filter-no-results.component.jsx"
import CourseSearch from "../components/course-filter/course-search.component.jsx"
import CourseSort from "../components/course-filter/course-filter-sort.component.jsx"

import characterCount from "../helpers/characterCount.helper"
import CourseFilter from "../components/course-filter/course-filter.component"
import queryString from "query-string"
import { filterData } from "../components/course-filter/options-data"
import ResetSVG from "../svg/Reset.svg"
import { getCourseData } from "../helpers/coursecard.helper.jsx"
import FooterCta from "../components/footer-cta/footer-cta.component"
import MobileContext from "../providers/mobile/mobile.provider"
import { FilterWrapper } from "../components/course-filter/course-filter.style.js"

export const Head = ({ location, data }) => {
  return (
    <Seo
      metaData={data.allContentfulPageMeta.nodes[0]}
      uri={location.pathname}
    />
  )
}

const CoursesIndex = (props) => {
  const pageMeta = get(props, "data.allContentfulPageMeta.nodes")[0]
  const heroText = get(
    pageMeta,
    "longHeroDescription.childMarkdownRemark.rawMarkdownBody"
  )
  
  const { isMobile } = useContext(MobileContext)
  const [selectedCategory, setSelectedCategory] = useState("all")
  const [selectedFormat, setSelectedFormat] = useState("all")
  const [selectedLevel, setSelectedLevel] = useState("all")
  const [selectedSubcategory, setSelectedSubcategory] = useState("all")
  const [isExpanded, setIsExpanded] = useState(false)
  const [query, setQuery] = useState("")

  const [isSearchSubmitted, setIsSearchSubmitted] = useState(false)

  const typoSize = characterCount(heroText)
  const courses = get(props, "data.contentfulGeneralSettings.courseCardOrdering")

  const mostPopular = courses

  const [searchData, setSearchData] = useState([])
  const [sortedSearchedCourses, setSortedSearchedCourses] = useState([])

  const businessCourses = courses.filter(course => course.filterCategories.includes("Business & Data") && course.isReady)
  const designCourses = courses.filter(course => course.filterCategories.includes("Design") && course.isReady)
  const web3Courses = courses.filter(course => course.filterCategories.includes("Web3 & Blockchain") && course.isReady)
  const lifeSkillsCourses = courses.filter(course => course.filterCategories.includes("Life Skills") && course.isReady)
  const devleopmentCourses = courses.filter(course => course.filterCategories.includes("Development") && course.isReady)
  const dataMachineLearningCourses = courses.filter(course => course.filterCategories.includes("A.I & Machine Learning") && course.isReady)
  const cloudDevopsCourses = courses.filter(course => course.filterCategories.includes("Cloud & DevOps") && course.isReady)
  const cyberSecurityCourses = courses.filter(course => course.filterCategories.includes("Cyber Security") && course.isReady)
  const buildWithAICourses = courses.filter(course => course.filterCategories.includes("Build With A.I.") && course.isReady)

  const courseStats = courses.reduce(
    (acc, course) => {
      const { totalLessons, totalHours } = course
      acc.lessons = acc.lessons + totalLessons
      acc.hours = acc.hours + totalHours
      acc.courses++
      return acc
    },
    {
      lessons: 0,
      hours: 0,
      courses: 0,
    }
  )

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  function roundDownToNearestHundred(x) {
    const roundedNumber = Math.floor(x / 100) * 100
    if (x === roundedNumber) return numberWithCommas(roundedNumber)
    else return `${numberWithCommas(roundedNumber)}+`
  }

  function roundDownToNearestHour(x) {
    const roundedHour = Math.floor(x)
    if (x === roundedHour) return numberWithCommas(roundedHour)
    else return `${numberWithCommas(roundedHour)}+`
  }

  const stats = [
    { value: roundDownToNearestHundred(courseStats.lessons), text: "lessons" },
    { value: `${roundDownToNearestHour(courseStats.hours)}`, text: "video hours" },
    { value: `${courseStats.courses}+`, text: "courses" },
  ]

  //   COURSE FILTER STARTS HERE
  const [courseFilter, setCourseFilter] = useState({
    primaryTag: "all",
    subcategoryTag: "all",
    secondaryTag: "all",
    formatTag: "all",
    sortByValue: "coursePopularity",
    showFilter: false,
    showResult: false,
  })

  const resetFilter = () => {
    setCourseFilter({
      primaryTag: "all",
      subcategoryTag: "all",
      secondaryTag: "all",
      formatTag: "all",
      sortByValue: "coursePopularity",
      showFilter: false,
      showResult: false,
    })
    setSelectedCategory("all")
    setSelectedFormat("all")
    setSelectedLevel("all")
    setSelectedSubcategory("all")
  }

  const resultMap = {
    all: courses,
    development: devleopmentCourses,
    business: businessCourses,
    business_data: businessCourses,
    design: designCourses,
    web3: web3Courses,
    web3_blockchain: web3Courses,
    life_skills: lifeSkillsCourses,
    data_and_machine_learning: dataMachineLearningCourses,
    ai_machine_learning: dataMachineLearningCourses,
    ai_and_machine_learning: dataMachineLearningCourses,
    cyber_security: cyberSecurityCourses,
    cloud_and_devops: cloudDevopsCourses,
    build_with_ai: buildWithAICourses,
  }

  const transformValue = (value) => {
    return value
      .toLowerCase()
      .replace(" & ", "_")
      .replaceAll(".", "")
      .replaceAll(" ", "_")
      .replace("/", "_")
  }

  const mostPopularCourses = mostPopular

  const mostPopularCoursesMostPopular = resultMap["all"].slice(0, 9)
  const mostPopularCoursesMostRecent = resultMap["all"].slice(0, 9).sort((a, b) => new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn))

  const resetSearch = () => {
    setQuery("")
    setSearchData([])
    setIsSearchSubmitted(false)
    resetFilter(setCourseFilter("most_popular"))
  }

  const clearSearch = () => {
    setQuery("");
    setSearchData([]);
    setIsSearchSubmitted(false);
  };

  const sortCourses = () => {
    if (!searchData.length) {
      return [];
    }
    if (courseFilter.sortByValue === "most_recent") {
      return [...searchData].sort((a, b) => new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn));
    } else if (courseFilter.sortByValue === "most_popular") {
      return [...searchData];
    }
    return searchData;
  };

  useEffect(() => {
    if (searchData.length > 0) {
      setSortedSearchedCourses(sortCourses());
    }

  },

    // eslint-disable-next-line
    [searchData, courseFilter])


  // EXECUTE SEARCH FUNCTION
  const executeSearch = () => {
    const lowerCaseQuery = query.toLowerCase()

    const courseSearchData = courses.filter(item => {
      const titleMatches = item.courseTitle.toLowerCase().includes(lowerCaseQuery);
      const excerptMatches = item.courseExcerpt.toLowerCase().includes(lowerCaseQuery);

      // Check if any author's name matches the query
      const authorsMatch = item.authors.some(author =>
        author.authorName.toLowerCase().includes(lowerCaseQuery)
      )

      return titleMatches || excerptMatches || authorsMatch;
    })

    setSearchData(courseSearchData);
    setIsSearchSubmitted(true)
    resetFilter()
  }


  const renderCourseResult = (primary = "all", subcategory, secondary, sortByValue, format) => {
    if (primary === "ai_and_machine_learning") primary = "ai_machine_learning"
    if (primary === "data_and_machine_learning") primary = "ai_machine_learning"
    if (primary === "cloud_devops") primary = "cloud_and_devops"
    const result = resultMap[primary]
    const sortByResult =
      sortByValue === "most_recent"
        ? [...result].sort(
          (a, b) =>
            new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn)
        )
        : result

    // Apply the filters 
    let filteredResults = sortByResult;

    // Apply subcategory filter

    if (primary !== "all" && subcategory) {
      const subcategoryFilteredResults = filteredResults.filter(course =>
        course.filterTopics?.some(topic => transformValue(topic) === subcategory)
      );
      // If no courses match the subcategory, fallback to the primary results
      filteredResults = subcategoryFilteredResults.length > 0 ? subcategoryFilteredResults : filteredResults;
    }
    // Apply secondary filter
    if (secondary !== "all") {
      filteredResults = filteredResults.filter(course =>
        course.filterLevels?.some(level => transformValue(level) === secondary)
      );
    }

    // Apply format filter
    if (format !== "all") {
      filteredResults = filteredResults.filter(course =>
        course.courseFormat?.some(courseFormat => transformValue(courseFormat) === format)
      );
    }

    return filteredResults;
  }

  const assetOrder = [
    "6MeLR36LWbFb6Ul7KCRMLx",
    "rHXEtuzX1jW3eoEQrT7JX",
    "5aukYoNaVHPpKOcghBjpe6",
    "el8s1qRlMyYRElBh0adf8"
  ]

  const sortedAssets = props.data.allContentfulAsset.nodes.sort((a, b) => {
    return assetOrder.indexOf(a.contentful_id) - assetOrder.indexOf(b.contentful_id)
  })

  const courseHeaderImages = sortedAssets.slice(0, 3)
  const lessonsImage = sortedAssets[0]
  const videosImage = sortedAssets[2]
  const coursesImage = sortedAssets[1]

  const noCoursesEmoji = sortedAssets[3]

  const { primaryTag, subcategoryTag, secondaryTag, sortByValue, showResult, formatTag } = courseFilter
  const filteredCourses = renderCourseResult(
    primaryTag,
    subcategoryTag,
    secondaryTag,
    sortByValue,
    formatTag,
  )

  const [queryParams, setQueryParams] = useState(false)

  useEffect(() => {
    const params = queryString.parse(props.location.search)
    setQueryParams(params)

    // After changing category namings we need to ensure the content teams query param links still work
    if (params.category === "coding") params.category = "development"
    if (params.category === "web3_blockchain") params.category = "web3"
    if (params.category === "ai_and_machine_learning")
      params.category = "ai_machine_learning"

    const { category, subcategory, topic, order, format } = params
    const hasParams = Object.keys(params).length !== 0

    const validateTag = (category, subcategory, topic, order, format) => {
      const validValues = filterData.validParamValues
      const validCategory = validValues.includes(category) ? category : "all"
      const validSubcategory = validValues.includes(subcategory)
        ? subcategory
        : "all"
      const validTopic = validValues.includes(topic) ? topic : "all"
      const validFormat = validValues.includes(format) ? format : "all"
      const validOrder = validValues.includes(order) ? order : "most_popular"

      setCourseFilter({
        ...courseFilter,
        primaryTag: validCategory,
        subcategoryTag: validSubcategory,
        secondaryTag: validTopic,
        formatTag: validFormat,
        sortByValue: validOrder,
        showFilter: false,
        showResult: hasParams, // only show result text when filter is applied
      })
    }

    validateTag(category, subcategory, topic, order, format)
    // eslint-disable-next-line
  }, [props.location.search])

  const renderCourses = () => {
    if (searchData.length > 0) {
      return (
        <>
          <ResultText>
            <p>Showing {searchData.length} search results</p>
            <SmallTextLinkContainer onClick={resetSearch} isCoursesPage={true}>
              <ResetSVG />
              <LabelContainer>RESET</LabelContainer>
            </SmallTextLinkContainer>
          </ResultText>
          <CourseCardsSection isCoursePage={true}>
            {sortedSearchedCourses.length
              ? getCourseData(
                sortedSearchedCourses,
                {
                  cardImage: "courseImageClick",
                  cardTitle: "courseTitleClick",
                  authorName: "courseAuthorClick",
                  buttonOne: "courseWatchPreviewBtnClick", //Course title
                  buttonTwo: "courseDetailsBtnClick",
                },
                "small-course-card"
              )
              : null}
          </CourseCardsSection>
        </>
      )
    }
    if (searchData.length === 0 && isSearchSubmitted) {
      return (
        <>
          <ResultText mr={30}>
            Showing {searchData.length} search results
            <SmallTextLinkContainer onClick={resetSearch} isCoursesPage={true}>
              <ResetSVG />
              <LabelContainer>RESET</LabelContainer>
            </SmallTextLinkContainer>
          </ResultText>
          <NoCourseResults
            noCoursesEmoji={noCoursesEmoji}
            mostPopularCourses={mostPopularCourses}
            courseFilter={courseFilter}
            mostPopularCoursesMostPopular={mostPopularCoursesMostPopular}
            mostPopularCoursesMostRecent={mostPopularCoursesMostRecent}
            isSearchSubmitted={isSearchSubmitted}
          />
        </>
      )
    }
    if (filteredCourses.length > 0) {
      return (
        <>
          <ResultText mr={30}>
            Showing {filteredCourses.length} filter results
            {showResult && (
              <SmallTextLinkContainer onClick={resetFilter} isCoursesPage={true}>
                <ResetSVG />
                <LabelContainer>RESET</LabelContainer>
              </SmallTextLinkContainer>
            )}
          </ResultText>
          <CourseCardsSection isCoursePage={true}>
            {filteredCourses.length
              ? getCourseData(
                filteredCourses,
                {
                  cardImage: "courseImageClick",
                  cardTitle: "courseTitleClick",
                  authorName: "courseAuthorClick",
                  buttonOne: "courseWatchPreviewBtnClick", //Course title
                  buttonTwo: "courseDetailsBtnClick",
                },
                "small-course-card"
              )
              : null}
          </CourseCardsSection>
        </>
      )
    }
    if (
      filteredCourses.length === 0 &&
      (primaryTag !== "all" ||
        subcategoryTag !== "all" ||
        secondaryTag !== "all" ||
        formatTag !== "all")
    ) {
      return (
        <>
          <ResultText mr={30}>
            Showing {filteredCourses.length} filter results
            <SmallTextLinkContainer onClick={resetFilter} isCoursesPage={true}>
              <ResetSVG />
              <LabelContainer>RESET</LabelContainer>
            </SmallTextLinkContainer>
          </ResultText>
          <NoCourseResults
            noCoursesEmoji={noCoursesEmoji}
            mostPopularCourses={mostPopularCourses}
            courseFilter={courseFilter}
          />
        </>
      )
    }
    return (
      <>
        <ResultText mr={30}>Showing {filteredCourses.length} results</ResultText>{" "}
        <CourseCardsSection isCoursePage={true}>
          {courses.length
            ? getCourseData(
              courses,
              {
                cardImage: "courseImageClick",
                cardTitle: "courseTitleClick",
                authorName: "courseAuthorClick",
                buttonOne: "courseWatchPreviewBtnClick", //Course title
                buttonTwo: "courseDetailsBtnClick",
              },
              "small-course-card"
            )
            : null}
        </CourseCardsSection>
      </>
    )
  }

  return (
    <PageLayout mb={100}>
      <Grid mb={[40, 40, 80, 80]}>
        <CoursesPageHero
          gridColumn={["1/-1", "1/-1", "span 6", "span 8"]}
          mb={[40, 40, 40, 0]}
          title={pageMeta.heroTitle}
          desc={
            <HeroDescriptionContainer
              typoSize={typoSize}
              dangerouslySetInnerHTML={{
                __html: pageMeta.longHeroDescription.childMarkdownRemark.html,
              }}
            />
          }
          courseHeaderImages={courseHeaderImages}
          lessonsImage={lessonsImage}
          videosImage={videosImage}
          coursesImage={coursesImage}
          stats={stats}
        />

        <SingleCTA
          ctaTitle={pageMeta.mainCtaTitle}
          btnText={pageMeta.ctaMainCtaButtonText}
          page={pageMeta.pageName}
          url={pageMeta.ctaMainCtaButtonUrl}
          gtmData={{
            event: "singleCTAButtonClick",
            location: "Course Page",
          }}
        />
      </Grid>
      <CoursesSection>
        <CoursesContainer style={{ maxWidth: "1340px", margin: "0 auto" }}>
          <>
            {isMobile && (
              <CourseSearch
                query={query}
                setQuery={setQuery}
                executeSearch={executeSearch}
              />
            )}
            <FilterWrapper mt={[15, 15, 0, 0]} mb={[15, 15, 60, 60]}>
              <CourseFilter
                courseFilter={courseFilter}
                setCourseFilter={setCourseFilter}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedFormat={selectedFormat}
                setSelectedFormat={setSelectedFormat}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                selectedSubcategory={selectedSubcategory}
                setSelectedSubcategory={setSelectedSubcategory}
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                resetSearch={resetSearch}
                clearSearch={clearSearch}
                setQuery={setQuery}
                hasQueryParams={queryParams}
                setQueryParams={setQueryParams}
              />
            </FilterWrapper>

            <div>
              <SearchSortContainer>
                {!isMobile && (
                  <CourseSearch
                    query={query}
                    setQuery={setQuery}
                    executeSearch={executeSearch}
                  />
                )}

                <CourseSort
                  courseFilter={courseFilter}
                  setCourseFilter={setCourseFilter}
                />
              </SearchSortContainer>
              {renderCourses()}
            </div>
          </>
        </CoursesContainer>
      </CoursesSection>
      <Grid>
        <EmailSubscribeHorizontal
          label={pageMeta.miscellaneousPageSettings.bottomCtaTitle}
        />
      </Grid>
      <FooterCta
        content={pageMeta?.footerCtaContent?.childMarkdownRemark?.html}
        buttonText={pageMeta?.footerCtaButtonText}
        linkUrl={pageMeta?.footerCtaLink}
      />
    </PageLayout>
  )
}

export default CoursesIndex

export const pageQuery = graphql`
  fragment courseCardInfo on ContentfulCourseCard {
    coursePromoUrl
    totalHours
    totalLessons
    courseTitle
    courseExcerpt
    courseUrl
    coursePopularity
    lastUpdatedOn
    isReady
    filterCategories
    filterTopics
    filterLevels
    courseFormat
    createdAt(formatString: "")
    badge {
      contentfulid
      title
      color
    }
    courseImage {
      gatsbyImageData(placeholder: BLURRED, width: 600)
      file {
        url
      }
    }
    authors {
      id
      authorName
      authorSlug
      profileImage {
        file {
          url
        }
      }
    }
  }
  query CoursesIndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulPageMeta(
      filter: { contentful_id: { eq: "4bpscxwIptNLJMAGBElLfh" } }
    ) {
      nodes {
        pageName
        pageTitle
        pageDescription
        pageRobots
        embedImage {
          file {
            url
          }
        }
        heroTitle
        longHeroDescription {
          childMarkdownRemark {
            html
            rawMarkdownBody
          }
        }
        mainCtaTitle
        mainCtaGroup
        ctaMainCtaButtonText
        ctaMainCtaButtonUrl
        alertBanner {
          enabled
          text {
            childMarkdownRemark {
              html
            }
          }
          isSticky
          bannerEndDate
          countdownEnabled
        }
        miscellaneousPageSettings {
          bottomCtaTitle
        }
        footerCtaContent {
          childMarkdownRemark {
            html
          }
        }
        footerCtaButtonText
        footerCtaLink
      }
    }
    contentfulCareerPathListingPage(
      contentful_id: { eq: "Jyc9t5cKdfslQkXLPKVUS" }
    ) {
      bottomCtaText {
        childMarkdownRemark {
          html
        }
      }
      bottomCtaButtonText
      bottomCtaButtonUrl
    }
    allContentfulAsset(
      filter: {
        contentful_id: {
          in: [
            "6MeLR36LWbFb6Ul7KCRMLx"
            "rHXEtuzX1jW3eoEQrT7JX"
            "5aukYoNaVHPpKOcghBjpe6"
            "el8s1qRlMyYRElBh0adf8"
          ]
        }
      }
    ) {
      nodes {
        contentful_id
        title
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED)
      }
    }
    contentfulGeneralSettings(contentful_id: { eq: "7dl3nxIwmnhQV0lux7Jm7z" }) {
      courseCardOrdering {
        ...courseCardInfo
      }
    }
  }
`
